(() => {
  if (window.__teeblessedMobileDrawerBound) return;
  window.__teeblessedMobileDrawerBound = true;

  const drawerSelector = '.teeblessed-mobile-drawer';

  document.addEventListener(
    'click',
    (event) => {
      const accordionSummary = event.target.closest(
        `${drawerSelector} [data-menu-drawer-accordion]`
      );

      if (accordionSummary) {
        event.stopPropagation();

        const details = accordionSummary.closest('details');
        window.requestAnimationFrame(() => {
          accordionSummary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        });
        return;
      }

      const closeButton = event.target.closest(`${drawerSelector} .tb-mobile-drawer__close`);
      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();

        const drawer = closeButton.closest(drawerSelector);
        const rootSummary = drawer?.querySelector(':scope > details > summary');
        rootSummary?.click();
        return;
      }

      const searchButton = event.target.closest(`${drawerSelector} .tb-mobile-drawer__search-button`);
      if (searchButton) {
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'keyup',
    (event) => {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      const drawer = event.target.closest(drawerSelector);
      if (!drawer) return;

      const rootDetails = drawer.querySelector(':scope > details');
      const nestedDetails = event.target.closest('.tb-mobile-drawer__details[open]');

      if (!nestedDetails || nestedDetails === rootDetails) return;

      event.stopPropagation();
      nestedDetails.open = false;

      const summary = nestedDetails.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', 'false');
      summary?.focus();
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => {
    const drawer = event.target.querySelector?.(drawerSelector);
    if (!drawer) return;

    drawer.querySelectorAll('[data-menu-drawer-accordion]').forEach((summary) => {
      summary.setAttribute('aria-expanded', summary.parentElement.open ? 'true' : 'false');
    });
  });
})();
